<template>
  <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
    <div
      class="toast-timer"
      :class="'toast-timer-variant-' + toast.variant"
      v-if="timer"
      :style="{ width: `${(timer / toast.timeout) * 100}%` }"
    ></div>
    <div class="toast-header" :class="'toast-header-variant-' + toast.variant">
      <Icon
        :icon="toast.variant"
        :size="20"
        v-if="toast.variant"
        :color="toast.color"
        class="toast-icon"
      />
      <div class="mr-auto toast-message">{{ toast.message }}</div>
      <Btn
        class="close"
        variant="PrimaryOutline"
        data-dismiss="toast"
        aria-label="Close"
        @click="close"
      >
        <Icon icon="close" :size="10" color="lambda" />
      </Btn>
    </div>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import Icon from "@/components/display/icon/Icon";
import store from "@/store";
import Toast from "@/classes/Toast";

export default {
  name: "Toast",
  props: {
    toast: Toast,
  },
  components: {
    Icon,
    Btn,
  },
  setup(props) {
    const timer = ref(props.toast?.timeout);
    const interval = ref(null);
    const countdownAmount = 25;

    const close = () => {
      store.dispatch("toasts/removeToast", props.toast);
    };

    onMounted(() => {
      if (timer.value && timer.value > 0) {
        interval.value = setInterval(() => {
          if (timer.value <= 0) {
            close();
          }
          timer.value -= countdownAmount;
        }, countdownAmount);
      }
    });

    onBeforeUnmount(() => {
      if (interval.value) {
        clearInterval(interval.value);
      }
    });

    return {
      close,
      timer,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.toast {
  opacity: 1;
  .toast-header {
    padding: 0.875rem 0.875rem;
    position: relative;
  }
  .toast-header-variant-info,
  .toast-header-variant-error,
  .toast-header-variant-success,
  .toast-header-variant-warning {
    border-left-width: 4px;
    border-left-style: solid;
  }
  .toast-timer {
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    opacity: 0.5;
  }
  .toast-icon {
    margin-right: 1.2rem;
  }
  .toast-message {
    margin-left: 1rem;
    padding-right: 1rem;
  }
  .close {
    position: absolute;
    right: 14px;
    top: 14px;
  }
  .icon.size-20 {
    width: auto;
  }
}
</style>
